import { gsap } from "gsap";
import type { ElementTweenFunction } from "../types";

/**
 * Finds the first `img` element within the target and sets its style to cover the container.
 * This is an immediate effect, not an animation over time.
 */
export const setImageToCover: ElementTweenFunction = ({ target }) => {
	const imgElement = target.querySelector("img");

	if (imgElement) {
		// Use gsap.set for immediate style application to the image
		const tween = gsap.set(imgElement, {
			objectFit: "cover",
			width: "100%", // Ensure image tries to fill the figure width
			height: "100%", // Ensure image tries to fill the figure height
		});
		// Position 0 indicates it should be added at the start of any timeline it's part of
		return { tween, position: 0 };
	}
	console.warn("setImageToCover: No <img> element found within the target:", target);
	// Return an empty object or similar to indicate no tween was created
	return { tween: undefined };
};
